import React from "react";
import TextHeroBlock from "theme/libs/wordpress/content/cmsBlocks/TextHeroBlock";
import { cmsTextContentProp } from "core-web/utils/proptypes/modules/textProps";

const TextHeroModule = ({ content }) => <TextHeroBlock content={content} />;

TextHeroModule.propTypes = {
    content: cmsTextContentProp,
};

TextHeroModule.defaultProps = {
    content: undefined,
};

export default TextHeroModule;
